/**
 * Every GraphQL document the «یکی کردن حساب‌ها» screen sends, built against the
 * contract in `parsina.bff.admin/src/graphql/typeDefs/accounts.js` (PM-0536 P5b,
 * PM-0546). One file, so a contract change is a diff against one place and a test
 * can match a call by its operation name.
 *
 * The Keycloak accounts are every environment's (one realm serves them all); the
 * records are THIS environment's.
 */

const RECORD_FIELDS = `
  id fullName nationalId birthDate gender phoneNumber keycloakUserId createdAt
`;

const ACCOUNT_FIELDS = `
  id username enabled firstName lastName createdAt
  phoneNumber phoneVerified formerPhoneNumber nationalId clinicId
  patientIdAttribute { value state record { ${RECORD_FIELDS} } }
  roles nonPatientRoles groups practitionerClinics
  records { ${RECORD_FIELDS} }
`;

export const PATIENT_ACCOUNTS_QUERY = `
  query PatientAccounts($phone: String, $nationalId: String) {
    patientAccounts(phone: $phone, nationalId: $nationalId) {
      configured
      accounts { ${ACCOUNT_FIELDS} }
      records { ${RECORD_FIELDS} }
    }
  }
`;

export const CONSOLIDATION_PREVIEW_QUERY = `
  query AccountConsolidationPreview($keepUserId: ID!, $dropUserId: ID!) {
    accountConsolidationPreview(keepUserId: $keepUserId, dropUserId: $dropUserId) {
      keep { ${ACCOUNT_FIELDS} }
      drop { ${ACCOUNT_FIELDS} }
      refusals { code message }
      allowed
      confirmationText
      formerPhoneNumberKept
    }
  }
`;

export const CONSOLIDATE_PATIENT_ACCOUNTS = `
  mutation ConsolidatePatientAccounts(
    $keepUserId: ID!, $dropUserId: ID!, $reason: String!, $confirmation: String!
  ) {
    consolidatePatientAccounts(
      keepUserId: $keepUserId, dropUserId: $dropUserId, reason: $reason, confirmation: $confirmation
    ) {
      result patientId mergeId mergedIds proofsMoved eventId
      formerPhoneNumber phoneNumberCleared disabled loggedOut patientIdAttribute
      failedStep notes
    }
  }
`;

export const RELEASE_PATIENT_ACCOUNT = `
  mutation ReleasePatientAccount($patientId: ID!, $keycloakUserId: ID!, $reason: String!) {
    releasePatientAccount(patientId: $patientId, keycloakUserId: $keycloakUserId, reason: $reason) {
      patientId eventId releasedAt
    }
  }
`;
